export default __webpack_public_path__ + "static/media/camp_demo_logo.8c75632c.png";